import { render, staticRenderFns } from "./CheckModule.vue?vue&type=template&id=4ce5dcd4&scoped=true&"
import script from "./CheckModule.vue?vue&type=script&lang=js&"
export * from "./CheckModule.vue?vue&type=script&lang=js&"
import style0 from "./CheckModule.vue?vue&type=style&index=0&id=4ce5dcd4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce5dcd4",
  null
  
)

export default component.exports